/* ============================================
   BASE STYLES - Shared by all variants
   ============================================ */

/* Container base styles */
.outerGroup {
    background-color: white;
    cursor: text;
    flex-wrap: wrap;
    align-items: center;
    box-shadow: none;
    border: 1px solid rgba(15, 15, 20, 0.2);
    border-radius: 0;
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-sm);

    @container (min-width: $mantine-breakpoint-sm) {
        padding: var(--mantine-spacing-md) var(--mantine-spacing-md);
    }

    transition:
        padding 0.25s ease,
        opacity var(--transition-duration-fast) var(--transition-ease-snappy),
        border var(--transition-duration-fast) var(--transition-ease-snappy),
        transform var(--transition-duration-fast) var(--transition-ease-snappy);
}

/* Container wrap state */
.outerGroupWrap {
    flex-direction: column;
    align-items: stretch;
}

/* Container hover/focus/active states */
.outerGroup:hover {
    border: 1px solid var(--dib-ink);
}

.outerGroup:focus-within,
.outerGroup:active {
    border: 1px solid var(--mantine-color-dibblue-5);
    box-shadow: inset 0 0 0 1px var(--mantine-color-dibblue-5);
    background-color: white;
}

/* Textarea wrapper */
.textareaWrapper {
    flex: 1;
}

/* Textarea input base */
.input {
    width: 100%;
    will-change: height;
    flex: 1;
    border: none;
    background-color: transparent;
    min-height: 0;
}

/* Remove scrollbar from textarea */
.input::-webkit-scrollbar {
    display: none;
}

/* Textarea input text */
.input {
    color: var(--dib-ink);
}

/* Textarea placeholder */
.input::placeholder {
    color: rgba(15, 15, 20, 0.5);
}

.input:focus::placeholder {
    color: transparent;
}

/* Hidden text for width calculation */
.hiddenText {
    position: absolute;
    visibility: hidden;
    white-space: pre-wrap;
    font-family: Lato;
}

/* Button group */
.buttonGroup {
    flex-wrap: nowrap;
    gap: var(--mantine-spacing-xs);
}

/* Send button base */
.sendButton {
    background-color: var(--dib-brand-base);
    color: white;
    border-radius: var(--mantine-radius-xl);
    transition: background-color 0.1s ease-in-out;
    /* Even dimensions keep the even-sized icon on whole pixels (no 0.5px
       rounding drift on 1x displays). */
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    padding: 0;

    @container (min-width: $mantine-breakpoint-sm) {
        width: 32px;
        height: 32px;
        min-width: 32px;
        min-height: 32px;
    }
}

.sendButton:hover {
    background-color: var(--dib-brand-base);
    color: white;
    opacity: 0.85;
}

.sendButton:disabled,
.sendButton[data-disabled] {
    background-color: var(--mantine-color-gneis-1);
    color: var(--mantine-color-gneis-6);
    opacity: 1;
    cursor: not-allowed;
}

.sendButton:disabled:hover,
.sendButton[data-disabled]:hover {
    background-color: var(--mantine-color-gneis-2);
    color: var(--mantine-color-gneis-6);
    opacity: 1;
}

.sendButtonInner {
    /* Reserved for any inner button styling if needed */
}

/* Icon base styles */
.icon {
    width: 100%;
    height: 100%;
}

.iconChevronRight {
    width: 16px;
    height: 16px;
}

/* ============================================
   KAI BRANDING PLACEHOLDER
   ============================================ */

.kaiBrandingPlaceholder {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    padding-left: 1px;
    pointer-events: none;
    color: var(--mantine-color-dark-3);
    font-size: var(--mantine-font-size-sm);
    white-space: nowrap;
    overflow: hidden;

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-lg);
    }
}

.kaiTag {
    display: inline-flex;
    align-items: center;
    background: var(--kai-brand-base);
    color: var(--kai-brand-accent);
    border-radius: var(--mantine-radius-sm);
    padding: 2px 7px;
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.04em;
    line-height: 1.4;

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-sm);
    }
}

/* ============================================
   SPLASH VARIANT STYLES
   ============================================ */

.outerGroup--splash {
    /* Inherits all base styles */
}

.input--splash {
    font-size: var(--mantine-font-size-sm);
    padding-left: 1px;

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-lg);
        line-height: 1.4;
        padding: 0;
    }
}

.outerGroup--splash .hiddenText {
    font-size: var(--mantine-font-size-sm);

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-lg);
    }
}

/* ============================================
   CHAT VARIANT STYLES
   ============================================ */

.outerGroup--chat {
    /* Inherits all base styles */
}

.input--chat {
    font-size: var(--mantine-font-size-sm);
    padding-left: 1px;

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-lg);
        line-height: 1.4;
        padding: 0;
    }
}

.outerGroup--chat .hiddenText {
    font-size: var(--mantine-font-size-sm);

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-lg);
    }
}
